/**
 * Build an API URL with optional query parameters.
 * Eliminates the repeated `params ? \`/path?${params.toString()}\` : '/path'` pattern.
 */
export function buildApiUrl(
	path: string,
	params?: URLSearchParams,
): string {
	return params ? `${path}?${params.toString()}` : path;
}
